module.exports = __webpack_public_path__ + "static/media/personal-development.eead92ef.svg";